// extracted by mini-css-extract-plugin
module.exports = {"options":"MultipleChoice_options__R696R","checkbox":"MultipleChoice_checkbox__X20tm"};